import { render, staticRenderFns } from "./SowTask.vue?vue&type=template&id=5c452c75&scoped=true&"
import script from "./SowTask.vue?vue&type=script&lang=js&"
export * from "./SowTask.vue?vue&type=script&lang=js&"
import style0 from "./SowTask.vue?vue&type=style&index=0&id=5c452c75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c452c75",
  null
  
)

export default component.exports